import { Directive } from '@angular/core';
import { FocusSelectDirective } from './focus-select.directive';
import { NoiceNumberDirective } from './noice-number.directive';
import { NumberOnlyDirective } from './number-only.directive';

@Directive({
  selector: '[opsNumber]',
  standalone: true,
  hostDirectives: [FocusSelectDirective, NoiceNumberDirective],
})
export class OpsNumberDirective {
  constructor() {}
}
//
// NumberOnlyDirective,
